export default "__VITE_ASSET__dzOy56Cp__"